// This file is AUTO-GENERATED by scripts/generate-runtime-configs.js
// Do not edit manually - your changes will be overwritten
// To add/remove secrets, edit APP_SECRETS.CREDIT_CARD_MATCHER in app-config.js and run: npm run generate:runtime-configs
//
// This file SHOULD be committed to git.
// In development: reads from import.meta.env (Vite's .env files)
// In production: placeholders (%%SECRET%%) get replaced by entrypoint.sh at container startup

const getEnvVar = (key: string, placeholder: string) => {
  // In development, import.meta.env is populated by Vite from .env files
  // In production build, this entire function gets tree-shaken and only the placeholder remains
  if (import.meta.env.DEV) {
    return import.meta.env[`VITE_${key}`] || placeholder;
  }
  return placeholder;
};

export const runtimeConfig = {
  LENDO_ENVIRONMENT: getEnvVar('LENDO_ENVIRONMENT', '%%LENDO_ENVIRONMENT%%'),
} as const;

// Helper to check if we're in production
export const isProduction = () => runtimeConfig.LENDO_ENVIRONMENT === 'pro';
